/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A conversation escalation
 */
export type ConversationEscalationResponse = {
    /**
     * Escalation ID
     */
    id: string;
    /**
     * Escalation status
     */
    status: ConversationEscalationResponse.status;
    /**
     * When the escalation was created
     */
    createdAt: string;
    /**
     * When the escalation was last updated
     */
    updatedAt: string;
};

export namespace ConversationEscalationResponse {

    /**
     * Escalation status
     */
    export enum status {
        OPEN = 'OPEN',
        RESOLVED = 'RESOLVED',
    }


}

